app.controller(
    'DashboardController', ['$scope', DashboardController]
);

function DashboardController($scope) {
  
};

